export default __webpack_public_path__ + "static/media/Aircraft7-t.b0786303.png";